export enum FwRulesFieldsEnum {
  Field = 'field' ,
  Operator = 'operator' ,
  Text = 'text' ,
  Chips = 'chips' ,
  Number = 'number' ,
  Boolean = 'boolean' , // default true
  Date = 'date' ,
  Regex = 'regex' ,
}
